var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"s-landing-page"},[_c(`SSymbols`,{tag:"component"}),_vm._v(" "),_vm._l((_vm.list),function(item,itemIndex){return [_c(`s-${item.name}`,{key:`s-${itemIndex}`,tag:"component",attrs:{"content":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }